import React from "react";

import {useParams} from "react-router-dom";
import MapVeoliaPage from "./MapVeoliaPage";

export default function Veolia() {
    const {id} = useParams();

    return (
        <MapVeoliaPage codeInsee={id}/>
    );
}
//69283
//33192
